<template>
    <div>
        <kgr-member-role-data-provider
            v-slot="rolesScope"
            :member-id="memberId"
            :callback="onRoleLoaded"
        >
            <kgr-form-scaffold
                :with-primary-buttons="false"
                @backBtnClicked="redirectToOverview"
            >
                <kgr-member-roles-data-form
                    :roles="roles"
                    :club-id="clubId"
                    :member-id="memberId"
                    class="animated fadeIn"
                    :is-creatable="isCreatable"
                    @updated="rolesScope.reload()"
                />
            </kgr-form-scaffold>
        </kgr-member-role-data-provider>
    </div>
</template>

<script>
import FormScaffold from '../../components/common/form/FormScaffold';
import MemberRoleDataProvider from '../../components/data-provider/MemberRoleDataProvider';
import MemberRolesDataForm from '../../components/members/roles/MemberRolesDataForm';

export default {
    components: {
        'kgr-member-roles-data-form': MemberRolesDataForm,
        'kgr-member-role-data-provider': MemberRoleDataProvider,
        'kgr-form-scaffold': FormScaffold,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true,
        },
        memberId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
        isCreatable: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            roles: [],
        };
    },
    methods: {
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
        onRoleLoaded(roles) {
            this.roles = roles;
        },
    },
};
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
